import dayjs from 'dayjs';

export const example_baseInfo = {
  organizationName: '',
  organizationType: 0, //机构类型 0-一般企业 1-政府机关 2-个体工商户 3-事业单位 4-社会团体 5-其他机构
  creditCode: '', //统一社会信用代码
  isMerge: 1, //是否三证合一 0-否 1-是
  qualificationCertificate: [
    //企业资质证书信息
    {
      type: 0, //0-三证合一，1-营业执照 2-组织机构代码证 3-税务登记证 4-事业单位法人证书/社会团体法人登记证书
      isLongEffective: 0, //0-否 1-是
      invalidDate: dayjs().format('YYYY-MM-DD'),
      fileUrl: '',
    },
  ],
  registerDate: '', //成立日期
  location: '',
  legalPerson: '', //法人代表
  registeredCapital: 0, //注册资金
  lastYearTaking: '', //上一年营收
  mainBusiness: '', //主营业务
  businessScope: '', //经营范围
  organizationAbstract: '', //机构简介
  uniteType: 0, //联合类型 0-主申报机构， 1-联合申报机构'
  responsibilityExplanation: '', //项目分工
};

export const example_addition = {
  propertyInfo: [
    //知识产权情况
    // {
    //   propertyName: "《基于xxxx的xxxx设计》",
    //   propertyType: "专利权",
    //   applyNumber: "CHA123456",
    //   fileUrl: [
    //     "https://xueshu.baidu.com/usercenter/paper/show?paperid=6b84a0fa739f93db94",
    //     "https://xueshu.baidu.com/usercenter/paper/show?paperid=6b84a0fa739f93db94",
    //   ],
    // },
  ],
  honorInfo: [
    //机构所获荣誉信息
    // {
    //   honorTime: "2019-10-10",
    //   honorProjectName: "一种基于xxx的xxx设计",
    //   honorRank: "一等奖第一名",
    //   honorInstitution: "中国化学学会",
    //   fileUrl:
    //     "https://xueshu.baidu.com/usercenter/paper/show?paperid=6b84a0fa739f93db94",
    // },
  ],
  otherCredentials: [
    //其他证明文件
    // "https://xueshu.baidu.com/usercenter/paper/show?paperid=6b84a0fa739f93db94",
    // "https://xueshu.baidu.com/usercenter/paper/show?paperid=6b84a0fa739f93db94",
  ],
};

// 青山科技个人信息
export const example_person = {
  idCardType: 1,
  idCardNo: '37062219990909002X',
  phone: '13688886666',
  email: '876876876@qq.com',
  companyName: '哈尔滨工业大学材料学院',
  eduInfo: [
    {
      startTime: '2000-09-01',
      endTime: '2002-06-10',
      collegeName: '哈尔滨工业大学',
      major: '材料成型',
      degreeType: 2,
    },
    {
      startTime: '1996-09-01',
      endTime: '2000-06-20',
      collegeName: '四川大学',
      major: '材料科学与技术',
      degreeType: 1,
    },
  ],
  workInfo: [
    {
      startTime: '2004-06-01',
      endTime: '2008-09-01',
      post: '副教授',
      workDesc: '主持省级重点科研项目《基于碳纳米纤维缝合的xxxx》',
      companyName: '清华大学',
    },
    {
      startTime: '2008-09-10',
      endTime: '2021-06-10',
      post: '教授',
      workDesc: '主持国家级重点科研项目《基于xxxx的xxxx设计》',
      companyName: '清华大学',
    },
  ],
  name: '美小团',
};

// 青山科技科研信息
export const example_study = {
  studyAreaType: 2, //1-专一领域，2-交叉领域
  studyArea: [1, 2], // 学科领域id
  authScientist: [
    {
      authName: '马化腾',
      authCompany: '腾讯',
    },
    {
      authName: '李教授',
      authCompany: '清华大学',
    },
  ],
  studyIssues: [1, 2], //科研议题id,最多可选中两个
  paper: [
    {
      paperName: '基于高分子蛋白的xxxxx研究', //最长不可超过50字
      journalName: '中国化学', //最长不可超过50字
      publishTime: '2019-10-10',
      author: '李一,王二,张三', //最长不可超过50字
      referenceNumber: 50, //只允许输入0～9999999999之间的整数；
      paperUrl: 'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html', //非必填
    },
    {
      paperName: '基于碳基化合物的xxxxx研究',
      journalName: '化学国际',
      publishTime: '2020-11-11',
      author: 'Mary,Tom,Jerry',
      referenceNumber: 100,
      paperUrl: 'https://wenku.baidu.com/view/69badba686868762caaedd3383c4bb4cf7ecb7a3.html', //非必填
    },
  ],
  honor: [
    {
      getTime: '2010-09-10',
      honorName: '中国节能减排大赛一等奖', //最长不可超过50字
      projectName: '基于xxx的xxxx设计', //最长不可超过50字
      honorRank: '一等奖第一名', //最长不可超过50字
      intitutionName: '中国化学学会', //最长不可超过50字
      fileUrl: [
        'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
        'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
      ], //非必填
    },
    {
      getTime: '2015-03-02',
      honorName: '中国xxx大赛一等奖',
      projectName: '基于xxx的xxxx设计',
      honorRank: '二等奖第二名',
      intitutionName: '中国化学学会',
      fileUrl: [
        'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
        'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
      ], //非必填
    },
  ],
  patent: [
    {
      nation: '中国', //最长不可超过50字
      type: '著作权', //最长不可超过50字
      name: '知识产权名称xxx', //最长不可超过50字
      rank: '第一完成人', //最长不可超过50字
      fileNumber: '12345XL', //最长不可超过50字
      fileUrl: 'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html', //非必填
    },
    {
      nation: '中国',
      type: '著作权',
      name: '知识产权名称xxx',
      rank: '第一完成人',
      fileNumber: '12345XL',
      fileUrl: 'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html', //非必填
    },
  ],
};

// 青山科技申报信息
export const example_apply = {
  progressDesc: 'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
  recommendInfo: [
    {
      name: '施一公',
      company: '西湖大学',
      job: '校长', //非必填
      phone: '13573566666', //非必填
      email: '123@sina.com', //非必填
      letterUrl: 'https://wenku.baidu.com/view/fab6afb40229bd64783e0912a216147917117e2a.html',
    },
    {
      name: '张连山',
      company: '清华大学',
      job: '教授',
      phone: '13583588888',
      email: 'abcd@sina.com',
      letterUrl: 'https://wenku.baidu.com/view/69badba686868762caaedd3383c4bb4cf7ecb7a3.html',
    },
  ],
};
